import { theme } from '@Guidelines/Theme/theme';
import type TranscriptSpeakerView from '@UI/Store/Interviews/Views/TranscriptSpeakerView';
import type * as React from 'react';
import { Tag, type TagStyle } from '@verclam/ui-kit';

const UNASSIGNED_KIND = 'unassigned';

// The maquette's tint for a nameless speaker (`:840`): unassigned is the only status that is not a
// neutral pairing, so it earns the one tint among the four states of the V-25 table (§9.6).
const unassignedTagStyle: TagStyle = {
	'--ui-kit-tag-bg': theme.tints.raspberry.surface,
	'--ui-kit-tag-text': theme.tints.raspberry.ink,
};

const neutralTagStyle: TagStyle = {
	'--ui-kit-tag-bg': theme.colors.surfaceMuted,
	'--ui-kit-tag-text': theme.colors.inkSecondary,
};

type Props = {
	readonly speaker: TranscriptSpeakerView;
};

/**
 * Reflects the speaker's current state, per the V-25 table (§9.6): unassigned reads its raw `label`
 * on a raspberry tint, every other `kind` reads `provenanceLabel` (already the getter's own rule —
 * never recomputed here) on a neutral pairing.
 */
const SpeakerAssignmentStatusTag: React.FC<Props> = ({ speaker }) => {
	const isUnassigned = speaker.kind.value === UNASSIGNED_KIND;

	return (
		<Tag
			value={isUnassigned ? speaker.label : speaker.provenanceLabel}
			style={isUnassigned ? unassignedTagStyle : neutralTagStyle}
		/>
	);
};

export default SpeakerAssignmentStatusTag;
